export default "__VITE_ASSET__CdpEOVLu__"